<template>
  <section class="section" v-if="!loading">
    <form v-if="active !== null">
      <b-field label="Category Name">
        <b-input type="text" v-model="active.name"></b-input>
      </b-field>
      <b-field label="Image">
        <image-upload @uploaded="onUpload" :imageid="active.imageId"></image-upload>
      </b-field>
    </form>
    <br />
    <b-field grouped>
      <div class="control">
        <button class="button" @click="$store.commit('adminCategories/setActive', null)">Cancel</button>
      </div>
      <div class="control">
        <button class="button is-primary" @click="createNew" v-if="active === null">Add Category</button>
        <button type="button" class="button is-primary" @click="save" v-else>Save</button>
      </div>
    </b-field>
  </section>
  <loader v-else></loader>
</template>

<script>
import BField from 'buefy/src/components/field/Field';
import BInput from 'buefy/src/components/input/Input';
import ImageUpload from './ImageUpload';
import Loader from '../Loader';

export default {
  components: {
    Loader,
    ImageUpload,
    BInput,
    BField,
  },

  name: 'category-editor',

  data() {
    return {
      loading: false,
    };
  },

  computed: {
    active() {
      return this.$store.state.adminCategories.active;
    },
  },

  methods: {
    createNew() {
      this.$store.commit('adminCategories/createBlank');
    },

    save() {
      this.loading = true;

      this.$store
        .dispatch('adminCategories/save', this.active)
        .then(() => this.$store.commit('adminCategories/setActive', null))
        .then(() => (this.loading = false));
    },

    onUpload(id) {
      // console.log('uploaded', id);
      this.$store.commit('adminCategories/setActiveImage', id);
    },
  },
};
</script>

<style scoped>
</style>


// WEBPACK FOOTER //
// src/components/admin/CategoryEditor.vue